import sanitizeHTML from "sanitize-html";

/**
 * Vue.prototype.$sanitize 用の sanitize-html オプション
 * 企画マッチング結果 HTML（button.theme-matching-issue + data-* + message）を残す
 */
export function createHtmlSanitizeOptions(): sanitizeHTML.IOptions {
  const defaultOptions = sanitizeHTML.defaults;
  return {
    allowedTags: [...(defaultOptions.allowedTags ?? []), "img", "button"],
    allowedAttributes: {
      ...defaultOptions.allowedAttributes,
      // sanitize-html は "data-*" の glob で data 属性を許可する（allowDataAttr は無効）
      // message は非標準属性のため button（.theme-matching-issue）にだけ許可する
      // 中期: BE を data-message に寄せれば button 個別の message 許可は不要になる
      "*": ["class", "data-*"],
      button: ["class", "type", "data-*", "message"],
      img: ["src"],
      a: [...(defaultOptions.allowedAttributes?.a ?? ["href", "name", "target"]), "rel"],
    },
    allowedSchemes: [...(defaultOptions.allowedSchemes ?? []), "data", "http", "https"],
  };
}

const htmlSanitizeOptions = createHtmlSanitizeOptions();

/** 企画マッチング結果などを含む HTML のサニタイズ */
export function sanitizeAppHtml(dirtyHtml: string): string {
  return sanitizeHTML(dirtyHtml, htmlSanitizeOptions);
}
